import React, { useContext, useEffect, useRef, useState } from 'react';
import style from './FlashCards.module.css';
import icons from '../../../icons';

import CategoryCard from './CategoryCard/CategoryCard';
import Category from './Category/Category';

import { Swiper, SwiperSlide } from 'swiper/react';
// import SwiperCore, { EffectFlip, Autoplay  } from 'swiper';
import 'swiper/swiper-bundle.css';

import { motion } from 'framer-motion';
import { AppContext } from '../../../AppContext';

import { getDocs, query, collection, where } from 'firebase/firestore';
import { db } from '../../../firebase';

import IconButton from '../../Buttons/IconButton/IconButton';

import Lottie from 'lottie-react';
import no_flashcards_animation from '../../../lottieAnimations/schedule_animation.json';


const FlashCards = props => {
    const { flashCards, setFlashCards, user } = useContext(AppContext);

    const [activeCategory, setActiveCategory] = useState(null);
    const [shownCategory, setShownCategory] = useState(0);
    const swiper = useRef();

    useEffect(() => {
        props.setShowTopBar(activeCategory == null);
        if (swiper.current)
            swiper.current.swiper.enabled = activeCategory == null;
    }, [activeCategory]);

    useEffect(() => {
        if (user && !flashCards)
            (async () => {
                setFlashCards((await getDocs(query(collection(db, `flashcards`), where("author", "==", user.id)))).docs
                    .map(doc => doc.data())
                    .reduce((object, item) => ({ ...object, [item.id]: item }), {}));
            })();
    }, [user, flashCards, setFlashCards]);

    return <main className={ style.main } style={{ height: activeCategory != null ? "100vh" : "calc(100vh - 7rem)" }}>
        <motion.div>
            {  Object.keys(flashCards ?? {}).length > 0 ?
                <Swiper ref={ swiper } slidesPerView={ 1.15 } onSlideChange={ (e) => setShownCategory(e.activeIndex) } enabled={ activeCategory == null } allowTouchMove={ activeCategory == null }>
                    { activeCategory === null ? 
                        Object.values(flashCards ?? {}).sort((first, second) => new Date(second.createdAt).getTime() - new Date(first.createdAt).getTime()).map((category, idx) => 
                            <SwiperSlide key={ `category-${category.id}` } onClick={ () => swiper.current.swiper.slideTo(idx) }>
                                <CategoryCard key={ `category-${idx}` } selected={ shownCategory === idx } activate={ () => setActiveCategory(idx) } category={ category } />
                            </SwiperSlide>) :
                        <Category showAdd={ props.showAdd } close={ () => {
                            const swiperSlide = activeCategory;
                            setActiveCategory(null);
                            setTimeout(() => swiper.current.swiper.slideTo(swiperSlide, 0), 0);
                        } } category={ Object.values(flashCards ?? {}).sort((first, second) => new Date(second.createdAt).getTime() - new Date(first.createdAt).getTime())[activeCategory] } edit={ () => {
                            props.setAddProps({ ...Object.values(flashCards ?? {}).sort((first, second) => new Date(second.createdAt).getTime() - new Date(first.createdAt).getTime())[activeCategory], type: "category" });
                            setActiveCategory(null);
                            props.showAdd();
                        } } 
                        setAddProps={ props.setAddProps } />
                    }
                </Swiper> :
                <>
                    <h4 style={{ textAlign: "center" }}>Ancora nessuna flashcard!</h4>
                    <Lottie 
                        style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "2rem", marginBottom: "2rem", marginLeft: "1rem", marginRight: "1rem" }}
                        loop={ true }
                        autoplay={ true }
                        speed={ 0.1 }
                        animationData={ no_flashcards_animation }
                        height={ 200 }
                        width={ 200 }
                    />   
                    <IconButton icon={ icons.add_icon } text="Nuova categoria" iconStyle={{ width: "1rem", height: "1rem" }} style={{ paddingTop: ".5rem", paddingBottom: ".5rem" }} onClick={ () => {
                        setActiveCategory(null);
                        props.showAdd();
                    } } />
                </>
            }
        </motion.div>
    </main>
}

export default FlashCards;